// extracted by mini-css-extract-plugin
export default {"nav-bar":"Test_nav-bar__olgWT","nav-button":"Test_nav-button__yX9+e","container-description":"Test_container-description__MRndE"};